module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 23
// module chunks = 0